<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch,computed } from "vue";
import * as echarts from 'echarts'
import 'echarts-wordcloud';

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
// watch(() => props.option.attribute, (obj) => {
//   processData(props.option.cptDataForm, newData, jsFunFlag)
//   loadChart(obj);
// }, { deep: true })
watch(() => [props.width, props.height], () => {
  if (chart) chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  let element = document.getElementById(uuid)
  if (!element) {
    return
  }

  chart = echarts.init(element)
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        let newarr = [];
        // 遍历原始数组并重组数据
        res.forEach(item => {
          let name = item[dataKey[0].value];
          let value = item[dataKey[1].value];

          // 创建新的对象并添加到 aa 数组中
          newarr.push({ name, value });
        });
        console.log(newarr, '新数组')
        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attr) {
  // let maskImage = new Image();//TODO 存在尺寸兼容问题
  // maskImage.src = require('@/assets/logo.png')
  chartOption = {
    tooltip: {
      trigger: 'item',
    },
    series: [{
      type: 'wordCloud',
      width: '100%',
      height: '100%',
      shape: attr.shape,
      // keepAspect: attr.keepAspect,
      // maskImage: maskImage,
      sizeRange: attr.sizeRange,
      rotationRange: [-90, 90],
      rotationStep: attr.rotationStep,
      gridSize: attr.gridSize,
      drawOutOfBound: attr.drawOutOfBound,
      shrinkToFit: true,
      layoutAnimation: true,
      textStyle: {
        fontWeight: attr.fontWeight,
        color: function () {
          let index = Math.floor(Math.random() * attr.color.length);
          return attr.color[index]
        }
      },
      emphasis: attr.emphasis,
      data: cptData
    }]
  }
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({ refreshCptData })
</script>
<style scoped></style>